/*
* <license header>
*/

import React, { useState, useMemo } from 'react'
import { SearchField, View } from '@adobe/react-spectrum'
import { PageHeaderBanner } from './shared/PageHeaderBanner'
import { TemplateCard } from './template-browser/TemplateCard'
import { AppAssistant } from './shared/AppAssistant'
import { APP_TEMPLATES } from '../data/constants'

export const AppTemplates = () => {
  const [filter, setFilter] = useState('')

  const filteredTemplates = useMemo(() => {
    if (!filter.trim()) return APP_TEMPLATES
    const query = filter.trim().toLowerCase()
    return APP_TEMPLATES.filter(
      (template) =>
        template.title.toLowerCase().includes(query) ||
        template.description.toLowerCase().includes(query) ||
        (template.useCase && template.useCase.toLowerCase().includes(query)) ||
        (template.appBuilderType && template.appBuilderType.toLowerCase().includes(query)) ||
        (template.technologies && template.technologies.some((t) => t.toLowerCase().includes(query))) ||
        template.badge.toLowerCase().includes(query)
    )
  }, [filter])

  return (
    <View width="100%" minWidth={0} padding="size-400" UNSAFE_style={{ paddingBottom: '2.5rem' }}>
      <PageHeaderBanner
        title="App Templates"
        subtitle="Real-world App Builder examples and reference implementations to inspire and accelerate your development"
      />

      <View padding="size-200" backgroundColor="gray-75" borderWidth="thin" borderColor="gray-300" borderRadius="regular" marginBottom="size-300">
        <SearchField
          aria-label="Search templates"
          placeholder="Search templates..."
          width="100%"
          value={filter}
          onChange={setFilter}
        />
      </View>

      <div
        className="AppTemplates-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 'var(--spectrum-global-dimension-size-300)',
          width: '100%',
          marginBottom: 'var(--spectrum-global-dimension-size-300)',
          alignItems: 'stretch'
        }}
      >
        {filteredTemplates.map((template) => (
          <div key={template.slug} style={{ minHeight: 0, display: 'flex', width: '100%', height: '100%' }}>
            <div style={{ flex: 1, minWidth: 0, display: 'flex' }}>
              <TemplateCard
                title={template.title}
            badge={template.badge}
            description={template.description}
            githubUrl={template.githubUrl}
            useCase={template.useCase}
                appBuilderType={template.appBuilderType}
                technologies={template.technologies}
              />
            </div>
          </div>
        ))}
      </div>

      <AppAssistant />
    </View>
  )
}
